import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'UIBtnArrow',
    props: {
        direction: { default: "next" },
        as: {},
        rounded: { type: Boolean, default: true },
        theme: {}
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            const _component_UIBtnIcon = _resolveComponent("UIBtnIcon");
            return (_openBlock(), _createBlock(_component_UIBtnIcon, _mergeProps({ class: "UIBtnArrow" }, props, {
                icon: _ctx.direction === 'prev' ? 'chevron-left' : 'chevron-right'
            }), null, 16, ["icon"]));
        };
    }
});
